const pathSVGs = {
  rectangle: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <path d="M10,10 L90,10 L90,90 L10,90 Z" fill="#e91e63"/>
  </svg>`,

  circle: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <path d="M50,10 A40,40 0 1,1 50,90 A40,40 0 1,1 50,10 Z" fill="#673ab7"/>
  </svg>`,

  triangle: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <path d="M50,10 L90,90 L10,90 Z" fill="#2196f3"/>
  </svg>`,

  hexagon: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <path d="M50,5 L95,25 L95,75 L50,95 L5,75 L5,25 Z" fill="#00897b"/>
  </svg>`,

  trapezoid: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <path d="M20,10 L80,10 L100,90 L0,90 Z" fill="#ff5722"/>
  </svg>`,

  line: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <path d="M0,50 L100,50 L100,55 L0,55 Z" fill="black"/>
  </svg>`
  // Add more shapes as needed
}

export default function useGetShapeSvg(name) {
  return pathSVGs[name]
}
